import React, { Component } from 'react';
import firebase from 'firebase';
import { message } from 'antd';
import { Container, Row, Col } from 'react-bootstrap';
import styled from 'styled-components';
import { Link, Redirect } from 'react-router-dom';
import connectScreen from '../../redux/connectScreen';
import Title from '../../components/Title';
import Input from '../../components/Input';
import Button from '../../components/Button';
import Label from '../../components/Label';

const AuthContainer = styled(Container)`
    padding: 80px;
    @media (max-width: 768px) {
        padding: 20px;
    }
`

const ResetAuthContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border: 1px solid #E8E8E8;
    min-height: 100%;
    padding: 5% 20% 5% 20%;
    max-height: calc(100vh - 200px);
    @media (max-width: 768px) {
        height: auto;
        padding: 20px 10px 20px 10px;
    }

`
const AuthTitle = styled(Title)`
    margin-bottom: 20px;
    @media (max-width: 768px) {
        margin-bottom: 20px;

    }
`
const AuthInput = styled(Input)`
    margin-bottom: 25px;
`
const InputContainer = styled.div`
    width: 100%;
`
class ResetPassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            loading: false
        }
    }
    async resetPassword() {
        try {
            const { email } = this.state
            await this.setState({ loading: true });
            await firebase.auth().sendPasswordResetEmail(email);
            await this.setState({ loading: false });
            message.success('Reset email sent!')

        } catch (e) {
            this.setState({ loading: false })
            message.error(e.message)
        }

    }
    render() {
        const { email, loading } = this.state;
        const { isLoggedIn } = this.props.user;
        if (isLoggedIn) return <Redirect to='/partners' />
        return (
            <AuthContainer fluid>
                <Row>
                    <Col>
                        <ResetAuthContainer>
                            <AuthTitle>
                                Reset
                            </AuthTitle>
                            <InputContainer>
                                <Label>Email</Label>
                                <AuthInput
                                    placeholder='Email'
                                    type='email'
                                    value={email}
                                    onChange={(e) => this.setState({ email: e.target.value })}
                                />
                            </InputContainer>
                            <Button
                                loading={loading}
                                onClick={() => this.resetPassword()}
                            >
                                Send Reset Link
                            </Button>
                            <Link to='/login'>
                                <Label style={{ marginTop: 20 }}>
                                    Remember your password?
                                </Label>
                            </Link>

                        </ResetAuthContainer>

                    </Col>
                </Row>
            </AuthContainer>
        )
    }
}

export default connectScreen(ResetPassword)